import React, { Component } from 'react'
import LoanStructureUI from './LoanStructureUI.js'

class LoanStructureSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      tokensDrawerMode: false,
      selectedPromoter: null,
      promoterUpdateMode: false,
    }
  }

  render() {
    return (
      <LoanStructureUI
        context={this.props.context}
        errorList={this.state.errorList}
        loan={this.props.loan}
        // events
        onRefreshClick={this.props.onRefreshClick}
        //
        updateMode={this.state.updateMode}
        onUpdateClick={() => { this.setState({ updateMode: true }) }}
        onUpdateCancel={() => { this.setState({ updateMode: false }) }}
        directorList={this.props.directorList}
        propertyList={this.props.propertyList}
        tokensDrawerMode={this.state.tokensDrawerMode}
        onTokensDrawerClick={() => { this.setState({ tokensDrawerMode: true }) }}
        onTokensDrawerCancel={() => { this.setState({ tokensDrawerMode: false }) }}
        selectedPromoter={this.state.selectedPromoter}
        promoterUpdateMode={this.state.promoterUpdateMode}
        onPromoterUpdateClick={this.onPromoterUpdateClick}
        onPromoterUpdateCancel={() => { this.setState({ promoterUpdateMode: false, selectedPromoter: null }) }}
      />
    )
  }

  onPromoterUpdateClick = (event) => {
    const userId = event.currentTarget.getAttribute('data-user-id')
    const selectedPromoter = this.props.directorList.find((user) => user.userId === userId)
    this.setState({ promoterUpdateMode: true, selectedPromoter })
  }
}

export default LoanStructureSF
